import * as ACTION_TYPES from '../types';

let initialState = {
  loading: true,
  dailyStatistics: [],
  weeklyStatistics: [],
  userTasks: [],
  modalTasks: [],
  modalLoading: false,
}

export default (state = initialState, action) => {
    switch (action.type) {
      case ACTION_TYPES.GET_DASHBOARD_DAILY_STATISTICS_REQUEST:
        return {...state };
      case ACTION_TYPES.GET_DASHBOARD_DAILY_STATISTICS_SUCCESS:
        return {...state, dailyStatistics: action.payload.data };
      case ACTION_TYPES.GET_DASHBOARD_DAILY_STATISTICS_FAILED:
        return {...state, loading: false };
      case ACTION_TYPES.GET_DASHBOARD_WEEKLY_STATISTICS_REQUEST:
        return {...state };
      case ACTION_TYPES.GET_DASHBOARD_WEEKLY_STATISTICS_SUCCESS:
        return {...state, weeklyStatistics: action.payload.data, loading: false };
      case ACTION_TYPES.GET_DASHBOARD_WEEKLY_STATISTICS_FAILED:
        return {...state, loading: false };
      case ACTION_TYPES.GET_DASHBOARD_USERTASKS_REQUEST:
        return {...state };
      case ACTION_TYPES.GET_DASHBOARD_USERTASKS_SUCCESS:
        return {...state, userTasks: action.payload.data };
      case ACTION_TYPES.GET_DASHBOARD_USERTASKS_FAILED:
        return {...state, loading: false };
      case ACTION_TYPES.GET_DASHBOARD_MODAL_TASKS_REQUEST:
        return {...state, modalLoading: true };
      case ACTION_TYPES.GET_DASHBOARD_MODAL_TASKS_SUCCESS:
        return {...state, modalTasks: action.payload.data, modalLoading: false };
      case ACTION_TYPES.GET_DASHBOARD_MODAL_TASKS_FAILED:
        return {...state, modalLoading: false };
      default:
        return state;
    }
  };